import { render, staticRenderFns } from "./BookPreviewPages.vue?vue&type=template&id=cf0e527a"
import script from "./BookPreviewPages.vue?vue&type=script&lang=js"
export * from "./BookPreviewPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports